// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".render-location-answer__text[data-v-6a86f8f0] a{font-weight:bold !important}\n", ""]);
// Exports
module.exports = exports;
